import { useEffect, useState } from 'react';
import {
  FaEnvelope,
  FaFacebookF,
  FaLinkedinIn,
  FaTiktok,
  FaWhatsapp,
  FaYoutube
} from 'react-icons/fa';
import hfnawiImage from './image/hfnawi_image.jpg';
import hfnawiLogo from './image/hfnawi_logo.jpeg';
import './profile.css';

const Portfolio = () => {
  // State for modal
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [modalImageSrc, setModalImageSrc] = useState('');
  const [modalImageAlt, setModalImageAlt] = useState('');

  // Handle image click
  const handleImageClick = (src, alt = '') => {
    setModalImageSrc(src);
    setModalImageAlt(alt);
    setIsModalOpen(true);
    document.body.style.overflow = 'hidden';
  };

  // Close modal
  const closeModal = () => {
    setIsModalOpen(false);
    document.body.style.overflow = 'auto';
  };

  // Handle ESC key press
  useEffect(() => {
    const handleKeyDown = (e) => {
      if (e.key === 'Escape' && isModalOpen) {
        closeModal();
      }
    };

    document.addEventListener('keydown', handleKeyDown);
    return () => {
      document.removeEventListener('keydown', handleKeyDown);
    };
  }, [isModalOpen]);

  return (
    <div className="container">
      {/* Profile Section */}
      <div className="profile">
        <img 
          src={hfnawiLogo} 
          alt="Profile Picture" 
          className="profile-img"
          onClick={() => handleImageClick(hfnawiLogo, "Profile Picture")}
        />
        <h1>ENG : Elhefnawy Dewidar</h1>
        <p className="tagline">Agricultural Engineer | Pesticide Specialist | Social Media Creator</p>
        
        <div className="bio-section">
          <p className="bio-text gradient-text-simple">
           A Social Media Creator and student in the College of Agriculture, pesticide, worked in many agricultural fields (pesticide store, farm, nurseries)
          </p>
        </div>
      </div>

      {/* Links Section */}
      <div className="links">
        {/* Social Media */}
        <div className="division">
          <a href="https://www.facebook.com/elhfnawee.dowidar.5?mibextid=ZbWKwL" target="_blank" rel="noopener noreferrer" className="link-btn facebook">
            <FaFacebookF /> Facebook 
          </a>
          <a href="https://www.youtube.com/@Eng-elhefnawy" target="_blank" rel="noopener noreferrer" className="link-btn youtube">
            <FaYoutube /> YouTube 
          </a>
        </div>

        {/* Messaging Apps */}
        <div className="division">
          <a href="https://wa.me/+201102118765" target="_blank" rel="noopener noreferrer" className="link-btn whatsapp">
            <FaWhatsapp /> WhatsApp
          </a>
          <a href="https://www.tiktok.com/@elhefnawyde?_t=ZS-8xky8XzR2fv&_r=1" target="_blank" rel="noopener noreferrer" className="link-btn tiktok">
            <FaTiktok /> TikTok 
          </a>
        </div>

        {/* Professional Networks */}
        <div className="division">
          <a style={{width: '100%'}} href="https://www.linkedin.com/in/eng-elhefnawy-dewidar-hnf-group-49bb84308?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app" 
            target="_blank" rel="noopener noreferrer" className="link-btn linkedin">
            <FaLinkedinIn /> LinkedIn 
          </a>
        </div>

        {/* Contact */}
        <div className="division">
          <a style={{width: '100%'}} href="mailto:elhefnaweedowidar21@gmail.com" className="link-btn email">
            <FaEnvelope /> Email
          </a>
        </div>
      </div>

      {/* Wave Section */}
      <div className="social-wave" style={{backgroundImage: `linear-gradient(to bottom, rgba(255,255,255,0.3), rgba(0,0,0,0.7)), url(${hfnawiImage})`}}>
        <div className="wave-container">
          {/* Wave SVG */}
          <svg className="wave" viewBox="0 0 1200 120" preserveAspectRatio="none">
            <path d="M0,0V46.29c47.79,22.2,103.59,32.17,158,28,70.36-5.37,136.33-33.31,206.8-37.5C438.64,32.43,512.34,53.67,583,72.05c69.27,18,138.3,24.88,209.4,13.08,36.15-6,69.85-17.84,104.45-29.34C989.49,25,1113-14.29,1200,52.47V0Z" opacity=".25" fill="currentColor"></path>
            <path d="M0,0V15.81C13,36.92,27.64,56.86,47.69,72.05,99.41,111.27,165,111,224.58,91.58c31.15-10.15,60.09-26.07,89.67-39.8,40.92-19,84.73-46,130.83-49.67,36.26-2.85,70.9,9.42,98.6,31.56,31.77,25.39,62.32,62,103.63,73,40.44,10.79,81.35-6.69,119.13-24.28s75.16-39,116.92-43.05c59.73-5.85,113.28,22.88,168.9,38.84,30.2,8.66,59,6.17,87.09-7.5,22.43-10.89,48-26.93,60.65-49.24V0Z" opacity=".5" fill="currentColor"></path>
            <path d="M0,0V5.63C149.93,59,314.09,71.32,475.83,42.57c43-7.64,84.23-20.12,127.61-26.46,59-8.63,112.48,12.24,165.56,35.4C827.93,77.22,886,95.24,951.2,90c86.53-7,172.46-45.71,248.8-84.81V0Z" fill="currentColor"></path>
          </svg>
          
          {/* Social Icons */}
          <div className="wave-social-icons">
            <a href="https://www.facebook.com/elhfnawee.dowidar.5?mibextid=ZbWKwL" className="wave-icon facebook" target="_blank" rel="noopener noreferrer">
              <FaFacebookF />
              <span className="wave-tooltip">Facebook</span>
            </a>
            <a href="https://www.youtube.com/@Eng-elhefnawy" className="wave-icon youtube" target="_blank" rel="noopener noreferrer">
              <FaYoutube />
              <span className="wave-tooltip">YouTube</span>
            </a>
            <a href="https://www.linkedin.com/in/eng-elhefnawy-dewidar-hnf-group-49bb84308?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app" 
              className="wave-icon linkedin" target="_blank" rel="noopener noreferrer">
              <FaLinkedinIn />
              <span className="wave-tooltip">LinkedIn</span>
            </a>
            <a href="https://wa.me/+201102118765" className="wave-icon whatsapp" target="_blank" rel="noopener noreferrer">
              <FaWhatsapp />
              <span className="wave-tooltip">WhatsApp</span>
            </a>
          </div>
        </div>

        {/* Watermark */}
        <div className="wave-watermark">
          <svg viewBox="0 0 1200 120" preserveAspectRatio="none">
            <path d="M0,0V46.29c47.79,22.2,103.59,32.17,158,28,70.36-5.37,136.33-33.31,206.8-37.5C438.64,32.43,512.34,53.67,583,72.05c69.27,18,138.3,24.88,209.4,13.08,36.15-6,69.85-17.84,104.45-29.34C989.49,25,1113-14.29,1200,52.47V0Z" opacity=".25" fill="currentColor"></path>
            <path d="M0,0V15.81C13,36.92,27.64,56.86,47.69,72.05,99.41,111.27,165,111,224.58,91.58c31.15-10.15,60.09-26.07,89.67-39.8,40.92-19,84.73-46,130.83-49.67,36.26-2.85,70.9,9.42,98.6,31.56,31.77,25.39,62.32,62,103.63,73,40.44,10.79,81.35-6.69,119.13-24.28s75.16-39,116.92-43.05c59.73-5.85,113.28,22.88,168.9,38.84,30.2,8.66,59,6.17,87.09-7.5,22.43-10.89,48-26.93,60.65-49.24V0Z" opacity=".5" fill="currentColor"></path>
          </svg>
          <p className="gradient-text-rainbow">© 2025 ENG El_Hfnawi. All Rights Reserved</p>
        </div>
      </div>

      {/* Image Modal */}
      {isModalOpen && (
        <div className="modal-overlay" onClick={closeModal}>
          <div className="modal-content" onClick={(e) => e.stopPropagation()}>
            <img 
              src={modalImageSrc} 
              alt={modalImageAlt}
              className="modal-image"
            />
            <button className="modal-close-btn" onClick={closeModal}>
              &times;
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default Portfolio;